import React from 'react';
import styles from './Statistics.less';
import DeviceStatus from '../../components/Statistics/DeviceStatus';
import StatisticsResource from '../../components/Statistics/StatisticsResource';
import StatisticsModal from '../../components/Statistics/StatisticsModal';
import { observer, inject } from 'mobx-react';
import StatisticsMap from '../../components/Statistics/StatisticsMap';
import { Tabs } from 'antd';

@inject('statisticsStore')
@observer
class Statistics extends React.Component {
  componentWillUnmount() {
    this.props.statisticsStore.statisticsModalStatus = false;
  }

  render() {
    const {
      columns,
      dataSource,
      hideModal,
      statisticsModalStatus,
      modalLoading,
      modalTitle
    } = this.props.statisticsStore;
    return (
      <div className={styles.statisticsCom}>
        <Tabs defaultActiveKey="0" style={{ backgroundColor: '#fff' }}>
          <Tabs.TabPane tab="设备位置分布" key="0">
            <div className={styles.top}>
              <div className={styles.mapContainer}>
                <StatisticsMap />
              </div>
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab="设备状态统计" key="1">
            <DeviceStatus />
            <StatisticsResource />
          </Tabs.TabPane>
        </Tabs>
        {statisticsModalStatus && (
          <StatisticsModal
            columns={columns}
            dataSource={dataSource}
            hideModal={hideModal}
            statisticsModalStatus={statisticsModalStatus}
            loading={modalLoading}
            title={modalTitle}
          />
        )}
      </div>
    );
  }
}
export default Statistics;



// WEBPACK FOOTER //
// ./src/pages/Statistics/Statistics.js